import { dark, light } from '@pancakeswap-libs/uikit'

light.colors = {
    background: "#ededf2",
    backgroundDisabled: "#E9EAEB",
    binance: "#F0B90B",
    borderColor: "#E9EAEB",
    card: "#FFFFFF",
    contrast: "#191326",
    failure: "#F72B50",
    input: "#eeeaf4",
    inputBorder: "#cccccc",
    invertedContrast: "#FFFFFF",
    primary: "#31c77f",
    primaryBright: "#e66000",
    primaryDark: "#d95b00",
    secondary: "#1f2937",
    success: "#31c77f",
    tertiary: "#EFF4F5",
    text: "#373737",
    textDisabled: "#BDC2C4",
    textSubtle: "#31c77f",
    warning: "#FFAB2D",
    gradients: {
        bubblegum: "linear-gradient(139.73deg, #E6FDFF 0%, #F3EFFF 100%)",
    },
}

export default light;